import { useContext } from 'react';
import ClaimContext from 'src/context/ClaimContext';

export default function () {
  return useContext(ClaimContext);
}